// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4015":"09e172c6","8220":"09e172c6"}[chunkId] + ".chunk.css";
};